import { SelectOption } from '@hum/legacy-ui';
import { createQuery } from '../../utils';

export const getTags = createQuery<SelectOption[]>(({ api }) => {
  return api
    .get('/v1/tags')
    .then((data) => data.tags.map((tag) => ({ label: tag, value: tag })));
});
